module.exports = __webpack_public_path__ + "static/img/about-banner.4b2e9f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-banner.png
// module id = URkD
// module chunks = 5